<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Em</h1>
          <figure class="image is-4by3">
            <img img class="zoom-default" data-zoom-src="static/images/em/em-pääkuva-uusi.jpg" src="static/images/em/em-pääkuva-uusi.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">
            Em chair was designed during my internship at Nordic Country Home in Ho Chi Minh City, Vietnam. I was inspired by the local hand weaving techniques and how they were utilized in the everyday objects. The weaving style used for the Em chair is commonly used in the traditional vietnamese litter baskets that can be spotted on the streets.
          </p>
          <p>The name ”Em” means little sister and describes the small size of the chair that was inspired by the local habit of sitting on very low small chairs on the street bars.
          </p>
          <br>
          <p>
            Photography: Matias Penttinen / Aino Michelsen
          </p>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/em/em_02.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image is-4by3">
            <img src="static/images/em/em_03.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default', {
      container: {
        top: 50
      }
    })
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Em_basket.vue